<template>
  <div>
    <v-snackbar
      v-for="(snackbar, index) in notification"
      bottom
      right
      :color="snackbar.type"
      :key="snackbar.id"
      :style="`bottom: ${(index * 54)}px`"
      :timeout="3500"
      :value="true"
      @input="close(snackbar.id)"
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          icon
          @click="close(snackbar.id)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Notifications',
  computed: {
    ...mapGetters({
      notification: 'notification/items',
    }),
  },
  methods: {
    ...mapActions({
      remove: 'notification/remove',
    }),
    close(id) {
      this.remove(id)
    }
  },
};
</script>
